export enum MemberListAction {
  None = 'NONE',
  Select = 'SELECT',
  Invite = 'INVITE',
}
